import type { Annotation } from "@rapid/types/annotation";
import type { AnnotationsForFileAndFrameId } from "@rapid/store/slices/modelIntentSlice";

/**
 * Returns annotations for a single frame within a file.
 * Used by ComputedValuesProvider for the current preview.
 */
export function getFrameAnnotations(
    store: AnnotationsForFileAndFrameId,
    fileId: string,
    frameId: string
): Annotation[] {
    return store[fileId]?.[frameId] ?? [];
}

/**
 * Returns all visible annotations for a media item in a grid context.
 *
 * When `flattenedVideoSourceId` is set, the item is an extracted video
 * frame — annotations live under `store[videoId][frameId]`.
 *
 * Otherwise, the item is a top-level file — annotations across all
 * frames are flattened into a single list.
 */
export function getAllAnnotationsForItem(
    store: AnnotationsForFileAndFrameId,
    mediaItemId: string,
    flattenedVideoSourceId: string | null
): Annotation[] {
    if (flattenedVideoSourceId) {
        return store[flattenedVideoSourceId]?.[mediaItemId] ?? [];
    }
    const perFrame = store[mediaItemId];
    return perFrame ? Object.values(perFrame).flat() : [];
}
